import { inject, Injectable } from '@angular/core';

import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN } from '@core/common-legacy';
import {
  HttpApiRequestOptions,
  HttpRequestData,
  IdentityHeader,
  IdentityHeaders,
} from '@core/http-types';
import { APP_GUID, ORG_GUID } from '@core/tellent-types';
import type { TellentAdminAppConfig } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentAdminRequestData extends HttpRequestData {
  protected config = inject<TellentAdminAppConfig>(APP_CONFIG);
  protected orgGuid = inject(ORG_GUID);

  private authMethod = inject(AUTH_METHOD);
  private authToken = inject(AUTH_TOKEN);
  private appGuid = inject(APP_GUID);

  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/api/org/' + this.orgGuid
    }${path}`;
  }

  public provideAuthHeaders(): { Authorization: string } {
    return { Authorization: `${this.authMethod} ${this.authToken}` };
  }

  public provideIdentityHeaders(): IdentityHeaders {
    const headers: IdentityHeaders = {};

    if (this.appGuid) {
      headers[IdentityHeader.TsApp] = this.appGuid;
    }

    if (this.orgGuid) {
      headers[IdentityHeader.TsOrg] = this.orgGuid;
    }

    return headers;
  }
}
